import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Space } from './style';
import Item from '../Item';
import { governorTabs, secretaryTabs, groupLeaderTabs } from '../helper';
import { useEffect } from 'react';

export const SidebarBody = () => {
  const { role } = useSelector((state) => state.authReducer);
  const { groups } = useSelector((state) => state.appReducer);

  useEffect(() => {
    return () => initialData();
  }, []);

  let governorTab;
  let groupLeaderTab;

  if (role === 'groupleader' && groupLeaderTabs[0]?.children.length === 1) {
    groupLeaderTabs[0].children.pop();
    groupLeaderTab = groupLeaderTabs[0].children.concat(
      groups.map((item) => ({
        title: item.title,
        id: item._id,
        path: `/${item.title}`,
      }))
    );
    groupLeaderTabs[0].children = groupLeaderTab;
  } else {
    if (governorTabs[0]?.children.length === 1) {
      governorTab = governorTabs[0].children.concat(
        groups.map((item) => ({
          title: item.title,
          id: item._id,
          path: `/${item.title}`,
        }))
      );
      governorTabs[0].children = governorTab;
    }
  }

  const sideItems = {
    governor: governorTabs,
    groupleader: groupLeaderTabs,
    groupsecretary: secretaryTabs,
    groupadmin: secretaryTabs,
  };

  const initialData = () => {
    governorTabs[0].children = [
      { title: 'Барча гуруҳлар', path: '/', id: 'all' },
    ];
    groupLeaderTabs[0].children = [
      { title: 'Барча гуруҳлар', path: '/', id: 'all' },
    ];
  };

  return (
    <Container>
      <Space />
      {sideItems[role].map(({ title, icon, path, children }, index) => (
        <Item
          key={`${index + 1}`}
          title={title}
          icon={icon}
          path={path}
          elements={children}
        />
      ))}
    </Container>
  );
};

export default React.memo(SidebarBody);
